/** Datos fiscales del producto que el timbrado CFDI exige. */
export interface ProductInvoiceSource {
  taxInclusive?: boolean | null;
  measureUnitId?: number | null;
  taxCodeId?: number | null;
  satObjetoImpId?: string | null;
}

export function missingProductInvoiceFields(source: ProductInvoiceSource | null | undefined): string[] {
  const missing: string[] = [];
  if (source?.taxInclusive == null) {
    missing.push('impuesto incluido');
  }
  if (source?.measureUnitId == null) {
    missing.push('unidad de medida');
  }
  if (source?.taxCodeId == null) {
    missing.push('código fiscal');
  }
  if (!source?.satObjetoImpId) {
    missing.push('objeto de impuesto SAT');
  }
  return missing;
}

export function productInvoiceReadinessMessage(productName: string, missing: string[]): string {
  return `El producto ${productName} no cumple los criterios de autofacturación porque le faltan datos fiscales: ${missing.join(', ')}.`;
}
